import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class AccountAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'Auth';
  controllerName = 'accounts';

  /**
   * Lấy token làm việc
   * Tham số gồm sid, tenant_id/database_id (tùy tình huống có gì truyền đó)
   */
  getToken(databaseId) {
    const request = {
      url: [this.getAPIUrl(), '/token/', databaseId].join(''),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu cho popup chọn dữ liệu làm việc
   */
  getTenants() {
    const request = {
      url: [this.getAPIUrl(), '/tenants'].join(''),
      params: param,
      withCredentials: true,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Đăng xuất
   */
  logout(payload) {
    const request = {
      url: [this.getAPIUrl(), '/logout'].join(''),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  // /**
  //  * Lấy thông tin phân quyền theo chi nhánh
  //  * Nếu không truyền thì sẽ đùng chi nhánh trong context
  //  */
  // getPermission(orgId) {
  // 	var url = [this.getAPIUrl(), 'permission'];
  // 	if (orgId) {
  // 		url.push(orgId);
  // 	}
  // 	let request = {
  //         url: url.join('/'),
  // 	};

  // 	return httpClient.getAsync(request);
  // }

  // /**
  //  * Đăng xuất khỏi ứng dụng
  //  */
  // logoff() {
  // 	let request = {
  //         url: [this.getAPIUrl(), 'logoff'].join('/'),
  // 	};

  // 	return httpClient.postAsync(request);
  // }

  /**
   * Đăng nhập
   */
  login(model) {
    const request = {
      url: [this.getAPIUrl(), 'login'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Đăng nhập dùng code với validation
   */
  loginCallback(model) {
    // Validate required parameters
    if (!model) {
      throw new Error('Model không được để trống');
    }

    const request = {
      url: [this.getAPIUrl(), 'login-callback'].join('/'),
      data: model,
    };

    return httpClient.postAsync(request);
  }

    /**
   * thực hiện lấy url cho iframe 2FA
   */
  Get2FAIframe(param) {
    const request = {
      url: this.getAPIUrl() +'/2fa-iframe',
      data: param
    };

    return httpClient.getAsync(request);
  }

  /**
   * Đăng nhập từ Fingov
   * Created by DTHieu1 22.10.2024
   */
  loginCallbackFingov(model) {
    const request = {
      url: [this.getAPIUrl(), 'fingov/callback'].join('/'),
      data: model,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy context theo sid khi đăng nhập vào từ amis
   */
  getContext(param) {
    const queryString = qs.stringify(param);
    const request = {
      url: [this.getAPIUrl(), '/context?', queryString].join(''),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Chuyển dữ liệu năm ngân sách
   *
   * @param {} param
   * @returns
   */
  async switchBudgetYear(param) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/switch-budget-year',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Chuyển thuê bao đơn vị lưỡng tính
   *
   * @param {} param
   * @returns
   */
  async switchTenant(param) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/switch-tenant',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Chuyển thuê bao nhóm tenant
   *
   * @param {} param
   * @returns
   */
  async switchGroupTenant(param) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/switch-group-tenant',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * rendert link login call sang misaid
   *
   * @actionName
   * @returns
   */
  async generateLinkLoginMisaId(actionName, misaIdAccessToken) {
    const request = {
      url:
        this.getAPIUrl() +
        `/generate-link-login-misaid?actionName=${actionName}&misaIdAccessToken=${misaIdAccessToken}`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * rendert user info misa id
   * vvvan 24.02.2025
   *
   * @actionName
   * @returns
   */
  async getUserInfo() {
    const request = {
      url: this.getAPIUrl() + `/user-info`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * rendert link login call sang misaid
   *
   * @actionName
   * @returns
   */
  async getUserInfoAvatar(email, misaToken) {
    const request = {
      url: this.getAPIUrl() + `/user-misa-id?email=${email}&misaToken=${misaToken}`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra session platform
   */
  checkSessionPlatform() {
    const request = {
      url: [this.getAPIUrl(), 'check-session'].join('/'),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Link yêu cầu cập nhật thông tin
   */
  async generateLinkUrlForce() {
    const request = {
      url: [this.getAPIUrl(), 'generate-link-url-force'].join('/'),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Xóa cache thông tin người dùng
   * @param {string} userId - ID người dùng cần xóa cache
   * @returns {Promise} Kết quả xóa cache
   */
  async clearUserCache(userId) {
    const request = {
      url: [this.getAPIUrl(), 'clear-user-cache', userId].join('/'),
    };

    return httpClient.postAsync(request);
  }
}

export default new AccountAPI();
